import { Grid } from '@ha/dsl';
import { makeStyles } from '@material-ui/core';
import React from 'react';

import { Control, SliderProps } from './types';

interface WithControlsProps {
  leftControl?: Control;
  rightControl?: Control;
}

const useStyles = makeStyles(() => ({
  control: {
    width: 'auto',
  },
  container: {
    overflow: 'hidden',
  },
}));

export default function withControls<P extends SliderProps>(
  Component: React.ComponentType<P>,
): React.FC<P & WithControlsProps> {
  const WithControls: React.FC<P & WithControlsProps> = props => {
    const { leftControl, rightControl } = props;
    const [index, setIndex] = React.useState<number>(0);
    const classes = useStyles();
    const nextSlide = React.useCallback(
      () => setIndex(index + 1),
      [index, setIndex],
    );
    const previousSlide = React.useCallback(
      () => setIndex(index - 1),
      [index, setIndex],
    );

    return (
      <Grid container>
        {leftControl && (
          <Grid alignItems="center" className={classes.control} container item>
            {leftControl({ previousSlide })}
          </Grid>
        )}
        <Grid item xs className={classes.container}>
          <Component index={index} onChangeIndex={setIndex} {...props} />
        </Grid>
        {rightControl && (
          <Grid alignItems="center" className={classes.control} container item>
            {rightControl({ nextSlide })}
          </Grid>
        )}
      </Grid>
    );
  };

  return WithControls;
}
